import {
  FieldType,
  OcrExtractedFieldType,
} from '../../../../../../../services/common/Constants';
import React from 'react';
import TextValue from '../textValue';
import NumericValue from '../numericValue';
import DateValue from '../dateCriterionValue';
import BooleanValue from '../booleanValue';

const OcrExtractedValue = ({
  selectedFieldSubType,
  selectedOperator,
  fieldName,
  showLabel,
  availableValueOptions,
  readOnly = false
}) => {
  switch (selectedFieldSubType) {
    case OcrExtractedFieldType.TEXT:
      return (
        <TextValue
          selectedOperator={selectedOperator}
          selectedFieldSubType={selectedFieldSubType}
          fieldName={fieldName}
          showLabel={showLabel}
          availableValueOptions={availableValueOptions}
          readOnly={readOnly}
        />
      );
    case OcrExtractedFieldType.NUMERIC:
      return (
        <NumericValue
          fieldName={fieldName}
          selectedOperator={selectedOperator}
          showLabel={showLabel}
          availableValueOptions={availableValueOptions}
          readOnly={readOnly}
        />
      );
    case OcrExtractedFieldType.DATE:
      return (
        <DateValue
          fieldName={fieldName}
          selectedOperator={selectedOperator}
          showLabel={showLabel}
          readOnly={readOnly}
        />
      );
    case OcrExtractedFieldType.BOOLEAN:
    case FieldType.BOOLEAN:
      return (
        <BooleanValue
          selectedOperator={selectedOperator}
          fieldName={fieldName}
          showLabel={showLabel}
          availableValueOptions={availableValueOptions}
          readOnly={readOnly}
        />
      );
    default:
      break;
  }
};

export default OcrExtractedValue;
